export function capitalizeFirstLetter(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
export default function formatUsername(name) {
    if (!name)
        return '';
    if (name.indexOf(' ') > -1) {
        var names = name.split(' ');
        var firstName = names[0];
        var middleOrLastNameInitial = names[1].charAt(0);
        return "".concat(firstName, " ").concat(middleOrLastNameInitial);
    }
    if (name.indexOf('@') > -1) {
        var firstPartOfEmail = name.split('@')[0];
        if (firstPartOfEmail.indexOf('.') > -1) {
            return capitalizeFirstLetter(firstPartOfEmail.split('.')[0]);
        }
        if (firstPartOfEmail.indexOf('_') > -1) {
            return capitalizeFirstLetter(firstPartOfEmail.split('_')[0]);
        }
        return capitalizeFirstLetter(firstPartOfEmail);
    }
    return name;
}
